module.exports = __webpack_public_path__ + "img/zu13.7921e0a9.svg";